import { object, string } from 'yup'
import { IBulkQuotingFormState } from 'apps/marketplace/store/bulkQuoting/types'

const bulkUploadSchema = {
  lanesFile: object().required('Must upload a file'),
  email: string().required('Must enter an email address'),
}
export interface IValidation {
  pristine: boolean
  errors: { [key: string]: string }
}

export interface IValidationErrors {
  ruleAction?: string
  spotPremium?: string
}

export const validateBulkUploadForm = (form: RecursivePartial<IBulkQuotingFormState>) => {
  try {
    return object().shape(bulkUploadSchema).validateSync(form, { abortEarly: false })
  } catch (errs) {
    const validationMessages = errs.inner.reduce(
      (acc: { [key: string]: string }, { message, path }: { path: string; message: string }) => {
        acc[path.split('.')[0]] = message
        return acc
      },
      {}
    )

    throw validationMessages
  }
}
